import { ComponentProps, FC, Ref } from "react";
import { Link as BaseLink } from "react-router-dom";

import { RouteDestination } from "config/types";
import { useNavigate } from "modules";

interface IProps extends ComponentProps<typeof BaseLink> {
  to: RouteDestination;
  state?: Record<string, unknown>;
  ref?: Ref<HTMLAnchorElement>;
}

export const Link: FC<IProps> = ({ onClick, replace = false, state, target, to, ref, ...rest }) => {
  const navigate = useNavigate();

  function handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    if (onClick) {
      onClick(event);
    }
    if (!event.defaultPrevented && event.button === 0 && (!target || target === "_self")) {
      event.preventDefault();
      navigate(to, { replace, state });
    }
  }

  return <BaseLink {...rest} to={to} onClick={handleClick} ref={ref} target={target} />;
};
